import { render, staticRenderFns } from "./SelectBuilding.vue?vue&type=template&id=25718d55"
import script from "./SelectBuilding.vue?vue&type=script&lang=js"
export * from "./SelectBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports